import React, { useEffect, useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  List,
  ListItem,
} from '@mui/material'
import { Clear as ClearIcon } from '@mui/icons-material'
import CircleIcon from '@mui/icons-material/Circle'
import { useStyles } from './SlidesStyles'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

export default function ReleaseValidation({
  isReleaseValidationOpen,
  handleReleaseValidationClose,
  slideDiagnosisValidation,
  consultValidation,
  caseDiagnosisValidation,
  recutValidation,
}) {
  const classes = useStyles()
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    if (isLoading) {
      setTimeout(() => setLoading(false), 7000)
    }
  }, [isLoading])

  return (
    <>
      <Dialog fullWidth maxWidth="sm" open={isReleaseValidationOpen} onClose={handleReleaseValidationClose}>
        <DialogTitle className={classes.dialogTitle}>Release Failed</DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText className={classes.dialogContent}>
            <>
              <ErrorOutlineIcon style={{ color: 'red', width: '50px', verticalAlign: 'middle' }} />
              <div>
                The report cannot be released as the following conditions are not met: <br />
                <List>
                  {caseDiagnosisValidation === false && (
                    <ListItem className={classes.validationListItem}>
                      <CircleIcon style={{ color: 'red', fontSize: 'small' }} />
                      <p style={{ marginLeft: '10px' }}>
                        Case diagnosis is not provided for one or more sample locations
                      </p>
                    </ListItem>
                  )}
                  {recutValidation === false && (
                    <ListItem className={classes.validationListItem}>
                      <CircleIcon style={{ color: 'red', fontSize: 'small' }} />
                      <p style={{ marginLeft: '10px' }}>Duplicate slide diagnosis is provided for one or more slides</p>
                    </ListItem>
                  )}
                  {consultValidation === false && (
                    <ListItem className={classes.validationListItem}>
                      <CircleIcon style={{ color: 'red', fontSize: 'small' }} />
                      <p style={{ marginLeft: '10px' }}>Consultation is mandatory for this case</p>
                    </ListItem>
                  )}
                  {slideDiagnosisValidation === false && (
                    <ListItem className={classes.validationListItem}>
                      <CircleIcon style={{ color: 'red', fontSize: 'small' }} />
                      <p style={{ marginLeft: '10px' }}>Slide diagnosis is not complete for one or more slides</p>
                    </ListItem>
                  )}
                </List>
              </div>
            </>
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.buttonActions}>
          <Button
            className={`${classes.buttonMargin}`}
            variant="outlined"
            endIcon={<ClearIcon />}
            onClick={handleReleaseValidationClose}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
